import { render, staticRenderFns } from "./v_play.vue?vue&type=template&id=a1c6f98c&scoped=true&"
import script from "./v_play.vue?vue&type=script&lang=js&"
export * from "./v_play.vue?vue&type=script&lang=js&"
import style0 from "./v_play.vue?vue&type=style&index=0&id=a1c6f98c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c6f98c",
  null
  
)

export default component.exports